import {
  derived
} from 'svelte/store';

import {
  map,
  forEach,
  orderBy,
  isEmpty,
  keyBy,
  find,
} from 'lodash-es';

import {
  events
} from '../config'

import {
  issueData
} from './dataStore';

import {
  hoveredIssuePage,
  hoveredDepartmentPage,
  departmentSorting
} from '../state/uiState';




function parseDate(str) {
  const dmy = str.split('.');
  return new Date(dmy[2], dmy[1] - 1, dmy[0]);
}

export const issues = derived(issueData, $issueData => {
  if ($issueData.length === 0) {
    return [];
  }

  return map($issueData, d => {
    const words = {}
    forEach(d.pages, p => {
      if (!isEmpty(p.words)) {
        forEach(p.words, (value, wid) => {
          if (words[wid] === undefined) {
            words[wid] = 0;
          }
          words[wid] += value;
        })
      }
    });

    return ({
      ...d,
      words: orderBy(map(words, (value, w) => ({
        'word': w,
        'value': value
      })), ['value', 'word'], ['desc', 'asc'])
    });
  });
});

export const issuesById = derived([issues], ([$issues]) => {
  if ($issues.length === 0) {
    return {};
  }
  return keyBy($issues, 'id')
});

export const departments = derived([issues, departmentSorting], ([$issues, $departmentSorting]) => {
  if ($issues.length === 0) {
    return [];
  }

  let departments = {}
  forEach(orderBy($issues, 'id', 'asc'), issue => {

    forEach(issue.pages, page => {
      if (page.department === '') {
        return
      }

      if (departments[page.department] === undefined) {
        departments[page.department] = {
          id: page.department,
          name: page.department,
          pages: [],
          words: {},
          infectedPages: 0,
          firstIssue: undefined,
          firstIssueDate: undefined
        };
      }
      departments[page.department].pages.push({
        page: page.page,
        issue: issue.id,
        infected: page.infected,
        items: page.items,
        words: {
          ...page.words
        }
      });

      if (page.infected > 0) {
        if (departments[page.department].firstIssue === undefined) {
          departments[page.department].firstIssue = issue.id
          departments[page.department].firstIssueDate = issue.date
        }
        departments[page.department].infectedPages += 1;
      }

      forEach(page.words, (value, word) => {
        if (departments[page.department].words[word] === undefined) {
          departments[page.department].words[word] = 0;
        }
        departments[page.department].words[word] += value;
      })
    })
  })
  departments = map(departments, d => ({
    ...d,
    pages: orderBy(d.pages, ['issue', 'page'], ['desc', 'asc']),
    words: orderBy(map(d.words, (value, w) => ({
      'word': w,
      'value': value
    })), ['value', 'word'], ['desc', 'asc'])
  }));

  if ($departmentSorting == 1) {
    return orderBy(departments, 'infectedPages', 'desc')
  } else {
    return orderBy(departments, ['firstIssue', 'infectedPages'], ['asc', 'desc'])
  }
});

export const issueItems = derived([issues], ([$issues]) => {
  if ($issues.length === 0 || events.length === 0) {
    return [];
  }
  let output = [];
  forEach($issues, d =>

    output.push({
      ...d,
      dateObj: parseDate(d.date),
      type: 'issue'
    }),
  );
  forEach(events, d =>
    output.push({
      ...d,
      dateObj: parseDate(d.date),
      type: 'event'
    }),
  );
  return orderBy(output, 'dateObj', 'desc');
});


export const hoveredIssuePageDetails = derived([issuesById, hoveredIssuePage], ([$issuesById, $hoveredIssuePage]) => {
  if (isEmpty($hoveredIssuePage === undefined || $issuesById)) {
    return {};
  }
  const issue = $issuesById[$hoveredIssuePage.issue];
  const page = find(issue.pages, d => d.page === $hoveredIssuePage.page);
  return {
    page: page.page,
    department: page.department == '' ? 'Kein Ressort' : page.department
  };
});

export const hoveredDepartmentPageDetails = derived([issuesById, hoveredDepartmentPage], ([$issuesById, $hoveredDepartmentPage]) => {
  if (isEmpty($hoveredDepartmentPage === undefined || $issuesById)) {
    return {};
  }
  const issue = $issuesById[$hoveredDepartmentPage.issue];
  return {
    page: $hoveredDepartmentPage.page,
    issue: `${issue.name} (${issue.date})`
  };
});

export const words = derived([issues], ([$issues]) => {
  if ($issues.length === 0) {
    return [];
  }
  const words = {};
  forEach($issues, d => {

    forEach(d.words, (w) => {
      if (words[w.word] === undefined) {
        words[w.word] = 0;
      }
      words[w.word] += w.value;
    })
  })
  return orderBy(map(words, (value, w) => ({
    'word': w,
    'value': value
  })), 'value', 'desc');
});


export const isReady = derived([issueItems, departments, words], ([$issueItems, $departments, $words]) => {
  return $issueItems.length !== 0 && $departments.length !== 0 && $words.length !== 0;
});